// composables/useSanitize.js
import DOMPurify from 'dompurify';

export function useSanitize(isInput) {
  const sanitize = (html) =>
    DOMPurify.sanitize(
      html,
      isInput
        ? {
            ALLOWED_TAGS: ['p', 'b', 'i', 'strong', 'em', 'br', 'span'], // only keep these
            ALLOWED_ATTR: [], // strip *all* attributes
          }
        : {},
    );
  return { sanitize };
}
